import { GET_ALL_USERS, GET_AUDIT_DATA } from './mutation-types'

export default {
  [GET_ALL_USERS]: (state, users) => {
    state.users = users
  },

  [GET_AUDIT_DATA]: (state, dadosAuditoria) => {
    state.dadosAuditoria = dadosAuditoria
  },
}
